// src/pages/Dashboard/components/Sidebar/CaseListItem.js

import React from 'react';

/**
 * Item individual da lista de casos no sidebar
 * @param {object} caso - Objeto do caso
 * @param {boolean} selected - Se está selecionado
 * @param {function} onClick - Callback ao clicar
 */
const CaseListItem = ({ caso, selected, onClick }) => {
  return (
    <div 
      className={`caso-item-menu ${selected ? 'selected' : ''}`}
      onClick={onClick}
    >
      <span className="caso-nome">{caso.name}</span>
      <span className="caso-data">
        {new Date(caso.created_at).toLocaleDateString('pt-BR')}
      </span>
    </div>
  );
};

export default CaseListItem;